import { SelfTestQuestion, SelfTestQuestionCollection } from "../../../../components/self-test/model/SelfTestQuestion";
import { result } from "./result";

export const questions: SelfTestQuestionCollection = {
    analytics: {
      slug: 'adpkd',
      resultText: (answers) => {
          const r = result(answers);
          return `parent_${r.parent_risk ? 'high' : 'low'}_risk_${r.risk ? 'high' : 'low'}`;
      }
    },
    showProgressBarAfterIndex: 2,
    questions: [
        {
            type: 'description',
            label: '開始',
            title: '您有多囊腎病病徵嗎？<br/><br/>',
            content: '除了家族史外，了解自己有沒有出現多囊腎病患者可能出現的病徵亦十分重要。<br/>只需回答6條簡單選擇題，就可了解自己的情況。<br/><br/><br/>',
            image: 'self-test/adpkd/q1.png',
            btnText: "開始評估",
        },
        {
            type: 'multiple-choice',
            label: '第零題',
            title: '<span class="self-test_description-title-override">為了解您的多囊腎病家族史，請先回答以下問題：</span>',
            content: '<span class="self-test_description-subtitle-override">您的父／母患有多囊腎病嗎<sup>10</sup>?</span>',
            image: 'self-test/adpkd/q0.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "沒有",
                    answer: "B",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第一題',
            title: '您的尿液曾呈粉紅／紅色，甚至啡色嗎<sup>10</sup>？',
            image: 'self-test/adpkd/q2.png',
            answers: [
                {
                    label: "有，持續了一段時間",
                    answer: "A",
                },
                {
                    label: "有，但只屬暫時性",
                    answer: "B",
                },
                {
                    label: "沒有",
                    answer: "C",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第二題',
            title: '您有腎結石嗎<sup>10</sup>？',
            image: 'self-test/adpkd/q3.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第三題',
            title: '您有高血壓嗎<sup>10</sup>？',
            image: 'self-test/adpkd/q4.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第四題',
            title: '您有尿頻、夜尿等尿道感染症狀嗎<sup>10</sup>？',
            image: 'self-test/adpkd/q5.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第五題',
            title: '您有腹痛／背痛嗎<sup>10</sup>？',
            image: 'self-test/adpkd/q6.png',
            answers: [
                {
                    label: "非常疼痛，痛楚一直持續",
                    answer: "A",
                },
                {
                    label: "間中",
                    answer: "B",
                },
                {
                    label: "輕微，甚至沒有",
                    answer: "C",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第六題',
            title: '您有水腫的問題嗎（尤其關節、腿、手）<sup>10</sup>？',
            image: 'self-test/adpkd/q7.png',
            answers: [
                {
                    label: "有",
                    answer: "A",
                },
                {
                    label: "無",
                    answer: "B",
                }
            ]
        },
    ]
};
